import {
  ProductListGroup,
  ProductListGroupId,
  Section,
} from "constants/modelCompareData/types";
import { doorAccessStarterKits } from "constants/modelCompareData/data/product-list-groups/doorAccessStarterKits";
import { doorAccessReadersIntercom } from "constants/modelCompareData/data/product-list-groups/doorAccessReadersIntercom";
import { doorAccessControlHubs } from "constants/modelCompareData/data/product-list-groups/doorAccessControlHubs";
import { AccessHubs } from "constants/modelCompareData/data/AccessHubs";
import { StarterKits } from "constants/modelCompareData/data/StarterKit";
import { Readers } from "constants/modelCompareData/data/Readers";

export type DoorAccessGroupId =
  | ProductListGroupId.DoorAccessStarterKits
  | ProductListGroupId.DoorAccessControlHubs
  | ProductListGroupId.DoorAccessReadersIntercom;

export const doorAccessTabs: Record<DoorAccessGroupId, ProductListGroup> = {
  [ProductListGroupId.DoorAccessStarterKits]: doorAccessStarterKits,
  [ProductListGroupId.DoorAccessControlHubs]: doorAccessControlHubs,
  [ProductListGroupId.DoorAccessReadersIntercom]: doorAccessReadersIntercom,
};

export const doorAccessSections: Record<DoorAccessGroupId, Section> = {
  [ProductListGroupId.DoorAccessStarterKits]: StarterKits,
  [ProductListGroupId.DoorAccessControlHubs]: AccessHubs,
  [ProductListGroupId.DoorAccessReadersIntercom]: Readers,
};
